<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="ratesService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'rates.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'rates.removingDialog' | translate }}
			<strong>{{ data.rate.currencyName }}</strong>
		</p>
	</div>
</alaris-dialog>
